import { type Observable, of, shareReplay } from 'rxjs';
import type { HttpDataResponse, PreviewResponse } from '@common/types/http-response.type';
import type { SiteCreateRequest, SiteEntity, UpdateSiteRequest } from '@common/types/site.type';
import type { DenormalizedBlockEntity } from '@web/types';

import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class SiteHttpService extends BaseHttpService {
    public getSite(siteId: string | number): Observable<SiteEntity> {
        return this.http.get<HttpDataResponse<SiteEntity>>(this.formatApiUrl(`sites/${siteId}`)).pipe(
            shareReplay(),
            map((res) => res.data),
            catchError(() => {
                return of(null);
            })
        );
    }

    public createSite(data: SiteCreateRequest): Observable<SiteEntity> {
        return this.http.post<HttpDataResponse<SiteEntity>>(this.formatApiUrl('sites'), data).pipe(
            shareReplay(),
            map((res) => res.data)
        );
    }

    public updateSite(siteId: string | number, payload: UpdateSiteRequest): Observable<SiteEntity> {
        return this.http.post<HttpDataResponse<SiteEntity>>(this.formatApiUrl(`sites/${siteId}`), payload).pipe(
            shareReplay(),
            map((res) => res.data)
        );
    }

    public getSitePreview(data: any): Observable<PreviewResponse> {
        return this.http
            .post<HttpDataResponse<PreviewResponse>>('/websites/builder/api/preview', data)
            .pipe(map((res) => res.data));
    }

    public copyBlockToPage(pageIds: number[], block: DenormalizedBlockEntity): Observable<any> {
        return this.http.post(this.formatApiUrl('blocks/insert-on-pages'), {
            pageIds,
            structure: JSON.stringify([block]),
        });
    }
}
